/**
 * The ghost Button turns its focus ring off; the Settings tab's icon buttons put the shared
 * Button ring back, so a keyboard user can see where they are.
 */
export const GHOST_FOCUS_RING = 'focus-visible:ring-[3px] focus-visible:ring-ring/50';

/** The shared Input's focus ring, for a field drawn as a box around a borderless textarea. */
export const TEXTAREA_BOX_FOCUS_RING =
	'transition-[color,box-shadow] has-[textarea:focus-visible]:border-gray-600 has-[textarea:focus-visible]:ring-[1.95px] has-[textarea:focus-visible]:ring-gray-500';
